
import { User, UserRole } from '../types';

const BASE_URL = 'https://api.coinnexs.com/api/admin/users';

export interface AdminUserDetail {
    profile: {
        id: string;
        name: string;
        email: string;
        role: string;
        status: string;
        createdAt: string;
    };
    security?: {
        lastLoginAt: string;
    };
    kyc?: {
        status: string;
        verificationLevel: string;
        submittedAt: string;
    };
}

export interface ListUsersParams {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    status?: string;
}

class AdminUsersService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<{ success: boolean; data?: T; message?: string; password?: string }> {
        const token = localStorage.getItem('coinnexs_token');
        const headers = {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            ...options.headers,
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data;
        } catch (error) {
            console.error(`Admin API Error (${endpoint}):`, error);
            return {
                success: false,
                message: 'Network error. Please try again later.',
            };
        }
    }

    async listUsers(params: ListUsersParams) {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.search) query.append('search', params.search);
        if (params.role && params.role !== 'ALL') query.append('role', params.role.toLowerCase());
        if (params.status && params.status !== 'ALL') query.append('status', params.status);

        const queryString = query.toString();
        return this.request<any[]>(queryString ? `?${queryString}` : '');
    }

    async getUserDetail(id: string) {
        return this.request<AdminUserDetail>(`/${id}`);
    }

    async showPassword(id: string) {
        return this.request<{ password: string }>(`/${id}/show-password`);
    }

    async suspendUser(id: string) {
        return this.request<void>(`/${id}/suspend`, { method: 'POST' });
    }

    async activateUser(id: string) {
        return this.request<void>(`/${id}/activate`, { method: 'POST' });
    }
}

export const adminUsersService = new AdminUsersService();
